import FormControl, { FormControlProps } from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { compose } from 'recompose';
import PinCodeInput from './PinCodeInput';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1),
      paddingTop: theme.spacing(2),
      // stop jumping screen components on error
      minHeight: '72px',
    },
    label: {
      letterSpacing: '0.4px',
    },
  });

export type IPinCodeTextField = {
  value?: string;
  codeLength?: number;
  cellSize?: number;
  cellSpacing?: number;
  placeholder?: string;
  password?: boolean;
  mask?: string;
  keyboardType?: string;
  autoFocus?: boolean;
  animationFocused?: string;
  helperText?: React.ReactNode;
  className?: string;
  onBackspace?();
  onTextChange?(change: string);
  onFulfill?(pin: string);
} & FormControlProps;

type Props = WithStyles<typeof styles> & IPinCodeTextField;
const PinCodeTextField = compose<Props, IPinCodeTextField>(
  withStyles(styles, {
    name: 'FdPinCodeTextField',
    withTheme: false,
  })
)(({ classes, ...props }) => {
  const helperTextId = props.helperText && props.id ? `${props.id}-helper-text` : undefined;

  return (
    <FormControl
      className={classes.root}
      error={props.error}
      fullWidth={props.fullWidth}
      variant={props.variant}
      margin="normal"
      disabled={props.disabled}
    >
      <InputLabel htmlFor={props.id} disableAnimation shrink className={classes.label}>
        <Translate id="number_digit_pin_code" />
      </InputLabel>

      <PinCodeInput
        id={props.id}
        autoFocus={props.autoFocus}
        disabled={props.disabled}
        error={props.error}
        onTextChange={props.onTextChange}
        onFulfill={props.onFulfill}
        password
      />

      {props.helperText && <FormHelperText id={helperTextId}>{props.helperText}</FormHelperText>}
    </FormControl>
  );
});

export default PinCodeTextField;
